import { useTranslation, Trans } from 'react-i18next';
import owner from '../../../assets/assets-homepage/img/owner.webp';

export default function FounderSafari() {
  const { t } = useTranslation('safari');
  return (
    <div className="founder lg:!py-[60px] sm:!py-10 !py-8">
      <div className="founder_sec1">
        <div className="container">
          <div className="founder__photo">
            <div>
              <img src={owner} alt={t('founder.alt')} />
            </div>
          </div>
        </div>
      </div>

      <div className="founder__text">
        <div className="container">
          <div className="max-w-[320px] sm:!max-w-[890px] text-center text-[#4A4A4A] mx-auto !text-xs sm:!text-base lg:!text-lg">
            <p className='leading-[20px] sm:leading-[29px]'>
              <Trans
                i18nKey="founder.quote"
                ns="safari"
                components={{ br1: <br /> }}
              />
            </p>
            <p className="mt-6 sm:mt-8 leading-[20px] sm:leading-[29px]">
              {t('founder.signatureName')}
              <br />
              {t('founder.signatureRole')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
